<template>
    <div v-if="cohort">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row" v-if="cohort.status == 'archived'">
                <div class="col-12">
                    <cohort-members :cohort="cohort" :ready="true" @change="changed"></cohort-members>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-6">
                    <platform-users :cohort="cohort" @ready="ready = true" @change="changed"></platform-users>
                </div>
                <div class="col-6">
                    <cohort-members :cohort="cohort" :ready="ready" @change="changed"></cohort-members>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PlatformUsers from './cohorts/PlatformUsers'
    import CohortMembers from './cohorts/CohortMembers'

    export default {

        components: {
            PlatformUsers, CohortMembers
        },

        data() {
            return {
                cohort: null,
                ready : false,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.cohorts'),
                        route: '/astral/ui/accounts/cohorts'
                    },
                    {
                        name: this.cohort.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/astral/api/front/cohorts/'+to.params.id, {params: {
                relations: ['members', 'parents'],
                accessors: ['has_registrations'],
            }})
            .then(resp => {
                next(vm => {
                    vm.cohort = resp.data.data
                })
            })
        },

        methods: {
            changed() {
                axios.get('/astral/api/front/cohorts/'+this.$route.params.id, {params: {
                    relations: ['members', 'parents'],
                    accessors: ['has_registrations'],
                }})
                .then(resp => {
                    this.cohort = resp.data.data
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>
